/*
 *
 * TermsPage reducer
 *
 */

import {
  FETCH_TERMS_SUCCESS,
  FETCH_TERMS_FAILURE,
} from './constants';

function termsPageReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_TERMS_SUCCESS:
      return {
        ...state,
        terms: action.payload
      };
    case FETCH_TERMS_FAILURE:
      return {
        ...state,
      };
    default:
      return state;
  }
}

export default termsPageReducer;



// WEBPACK FOOTER //
// ./src/containers/TermsPage/reducer.js